angular
  .module('fromNowFilter', [])
  .filter('fromNow', () => (date) => moment(date).fromNow());
